import {isValidElement} from 'react'
import {roles} from '@eitje/bridge'

const getTriggerProps = trigger => {
	if (isValidElement(trigger)) return trigger.props
	return trigger
}

export const useTriggerDisabled = trigger => {
	const {disabled, enableRole, roleEnv} = getTriggerProps(trigger)
	const roleDisabled = roles.useRoleMessage(enableRole && {roles: enableRole, env: roleEnv})

	return roleDisabled || disabled
}
